<template>
    <div>Redirigiendo....</div>
</template>

<script>
export default {
    name: 'default',
    created(){
        window.location = "http://d2.bdtr.net/Newscast"
    }
}
</script>